export default __webpack_public_path__ + "static/media/assetImg.03595c75.png";